var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 6,
    viewBox: "0 0 5 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.265869 2.53007V1.58385C0.265869 0.410828 1.09868 -0.0711398 2.11578 0.517144L2.93441 0.992024L3.75305 1.4669C4.77014 2.05519 4.77014 3.01558 3.75305 3.60386L2.93441 4.07875L2.11578 4.55363C1.09868 5.13128 0.265869 4.65285 0.265869 3.47629V2.53007Z",
    fill: "#7C7C7D",
    stroke: "#7C7C7D",
    strokeWidth: 0.531582,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldArrow);
export default __webpack_public_path__ + "static/media/bold-arrow.c456c147dc1bdc3700ab3741e9c67c60.svg";
export { ForwardRef as ReactComponent };